import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { isRtl, LocaleContext } from '../../../i18n/src';
import { ICON_MAP } from './icon.map';
import { ICON_ANIMATION_MAP, ICON_COLOR_MAP, ICON_SIZES_MAP } from './icon.types';
/**
 * Icons provide a visual language that quickly communicates actions. They can be informational or interactive.
 */
export const Icon = ({ animation = 'none', color = 'iconDefault', custom, name, onClick, size = 'base', }) => {
    const locale = useContext(LocaleContext);
    const registered = name ? ICON_MAP[name] : undefined;
    const IconComponent = custom !== null && custom !== void 0 ? custom : registered === null || registered === void 0 ? void 0 : registered.IconComponent;
    if (!IconComponent) {
        return null;
    }
    /**
     * Rotate or flip the icon based on the current locale and the icon's map metadata.
     * `verticalReverse` is a one-way flip (no LTR counterpart) — no current need for that.
     */
    const getOrientationStyles = () => {
        if (!registered) {
            return '';
        }
        const rtl = registered.supportsRTL && isRtl(locale);
        if (registered.verticalReverse ||
            (registered.horizontalReverse && !rtl) ||
            (!registered.horizontalReverse && rtl)) {
            return 'nucleus-transform nucleus-rotate-180';
        }
        return '';
    };
    const className = [
        // `non-scaling-stroke` keeps outline strokes a constant on-screen width
        // (the icons declare the Heroicons-standard 1.5) regardless of the rendered
        // size. Without it a 1.5 stroke in a 24-unit viewBox shrinks below 1.5px
        // whenever the icon renders smaller than 24px (e.g. 20px chevrons ≈ 1.25px).
        // Solid (fill-only) icons have no stroke, so this is a no-op for them.
        'nucleus-inline-block nucleus-box-border nucleus-align-middle [&_*]:[vector-effect:non-scaling-stroke]',
        ICON_COLOR_MAP[color],
        getOrientationStyles(),
        typeof size === 'string' ? ICON_SIZES_MAP[size] : '',
        onClick ? 'nucleus-cursor-pointer' : '',
        ICON_ANIMATION_MAP[animation],
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx(IconComponent, { className: className, name: name, onClick: onClick, role: 'img', size: typeof size === 'number' ? size : undefined }));
};
//# sourceMappingURL=icon.component.js.map